export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-thumbnail-480-3846f4d50351794ccd0f555ea11cb7cc.webp";